function About(){
    return(
  
<section className="py-3 py-md-5 py-xl-8">
  <div className="container py-3 py-md-5 py-xl-8">
    <div className="row gy-3 gy-md-4 gy-lg-0 align-items-lg-center">
      <div className="col-12 col-lg-6 col-xl-5" >
        <video width='100%' height='100%' autoPlay muted loop  className="" loading="lazy" src="/assets/a.mp4" alt="" />
      </div>
      <div className="col-12 col-lg-6 col-xl-7">
        <div className="row justify-content-xl-center">
          <div className="col-12 col-xl-11">
            <h2 className="h1 mb-3">MOVING FORWARD TOGETHER</h2>
            <p className="lead fs-4 text-secondary mb-3">Our purpose is to move the world forward through the power of sport. Worldwide, we're leveling the playing field, doing our part to protect our collective playground and expanding access to sport for everyone.</p>
            <p className="mb-5">Nullam gravida orci ac luctus molestie. Fusce finibus congue erat, non aliquam magna tincidunt at. Aenean lacinia arcu ex, sed pharetra nibh porta a. Curabitur vel consequat nibh, ac interdum nisl. Nunc pulvinar nec massa vitae sollicitudin.</p>
            
          </div>
        </div>
      </div>
    </div>
  </div>
  <iframe width= '100%' height="491" src="https://www.youtube.com/embed/d0HjV6r8ahU" title="Top 5 BEST NIKE DUNKS 2023" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"></iframe>
</section>
    );
} export default About;